import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPurchaseorderDetail } from "../../../Utility/Api";
import { numberToWords } from "../../../Utility/function";
import { FaJoint } from "react-icons/fa";

const PurchasePDF = () => {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [OrderList, setOrderList] = useState([]);
  const [Overall, setOverall] = useState(0);
  const modalContentRef = useRef(null);
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const paidAmount = state.payment
    ?.filter((item) => item.mop != "2")
    .reduce((sum, item) => sum + parseInt(item.amount || 0), 0);

  useEffect(() => {
    console.log(state);
    console.log("payment", state.payment);
    getPurchasedOrderList(state);
  }, []);

  const getPurchasedOrderList = async (Purchase) => {
    var res = await getPurchaseorderDetail(Purchase.po);
    var dataList = res.data.data.map(
      (item) => parseInt(item.qty) * parseInt(item.price)
    );
    const sum = dataList.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    setOverall(sum);
    setOrderList(res.data.data);
  };

  const componentRef = useRef(null);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const toggleExpand = (index) => {
    setExpandedIndex(prev => (prev === index ? null : index));
  };
  return (
    <>
      <div className="container justify-content-center pt-2">
        <div className="col-6 d-flex column-gap-3 align-items-center">
          <button
            className="btn py-1 btn-secondary text-small d-none"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </div>
      {/* <div ref={modalContentRef}>
        <div className="container my-3 bg-white  border  col-12"> */}
      <div className="d-flex justify-content-center p-3 bg-light min-vh-100" ref={modalContentRef}>
        <div className="bg-white border shadow-sm p-4 w-100 rounded" style={{ maxWidth: "850px" }}>

          <div className="row border-top border-bottom  pt-3 pb-2">
            <div className="col-6 ">
              <div
                className="p-2"
                style={{
                  border: ".8px solid #dee2e6",
                  minHeight: 150,
                }}
              >
                <h6 className="fw-bold">
                  {selectedLanguage === "arabic"
                    ? "تفاصيل المورد:"
                    : "Supplier Details:"}
                </h6>
                <div className="d-flex justify-content-between">
                  <p className="fw-medium font-13 mb-1">
                    {selectedLanguage === "arabic" ? "الاسم:" : "Name:"}
                  </p>
                  <p
                    className="fw-bold font-13 mb-1"
                    style={{ textDecoration: "underline" }}
                  >
                    {state.supplier_name}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-medium font-13 mb-1">
                    {selectedLanguage === "arabic"
                      ? "البريد الإلكتروني:"
                      : "Email:"}
                  </p>
                  <p
                    className="fw-bold font-13 mb-1"
                    style={{ textDecoration: "underline" }}
                  >
                    {state.supplier_email}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-medium font-13 mb-1">
                    {selectedLanguage === "arabic" ? "العنوان:" : "Address:"}
                  </p>
                  <p
                    className="fw-bold font-13 mb-1"
                    style={{ textDecoration: "underline" }}
                  >
                    {state.supplier_address}
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="fw-medium font-13 mb-1">
                    {selectedLanguage === "arabic" ? "الهاتف:" : "Phone:"}
                  </p>
                  <p
                    className="fw-bold font-13 mb-1"
                    style={{ textDecoration: "underline" }}
                  >
                    {state.supplier_phone}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-6">
              <table className="table table-bordered  text-center align-middle m-0">
                <tbody>
                  <tr className='hight-header'>
                    <td className="text-start fw-bold">
                      {selectedLanguage === "arabic"
                        ? "رقم الفاتورة:"
                        : "Invoice No:"}{" "}
                      {state.po}
                    </td>
                    <td className="text-start fw-bold">
                      {selectedLanguage === "arabic" ? "التاريخ:" : "Date:"}{" "}
                      {state.date}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered text-center align-middle">
                <tbody>
                  <tr>
                    <td className="text-start d-flex flex-row">
                      <p
                        className="fw-bold text-start mb-0"
                        style={{ width: "40%" }}
                      >
                        {selectedLanguage === "arabic"
                          ? "رقم الطلب:"
                          : "L.P.O No:"}
                      </p>
                      <p className="text-start mb-0" style={{ width: "60%" }}>
                        {state?.lpo_no}{" "}
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td className="text-start d-flex flex-row">
                      <p
                        className="fw-bold text-start mb-0"
                        style={{ width: "40%" }}
                      >
                        {selectedLanguage === "arabic"
                          ? "البائع:"
                          : "Sales Person:"}
                      </p>
                      <p className="text-start mb-0" style={{ width: "60%" }}>
                        {state?.user_name}{" "}
                      </p>
                    </td>
                  </tr>
                  {/* <tr>
                      <td className="text-start d-flex flex-row">
                        <p
                          className="fw-bold text-start mb-0"
                          style={{ width: "40%" }}
                        >
                          {selectedLanguage === "arabic"
                            ? "شروط الدفع:"
                            : "Payment Terms:"}
                        </p>
                        <p className="text-start mb-0" style={{ width: "60%" }}>
                          {state.mop || (state.purchase_unit == 1 ? "Cash" : "Credit")}
                        </p>
                      </td>
                    </tr> */}
                </tbody>
              </table>
            </div>
          </div>

          <div
            className="row p-3"
            style={{
              position: "relative",
              overflow: "hidden",
              backgroundSize: "60%",
              backgroundPosition: "center",
            }}
          >
            <table className="table table-bordered  text-center align-middle mt-1 mb-0 bg-transparent  border-dark">
              <thead className="bg-dark ">
                <tr className="bg-primary ">
                  <th className="bg-transparent ">
                    <span>
                      {selectedLanguage === "arabic" ? "الرقم" : "SL No."}
                    </span>
                  </th>
                  <th className="bg-transparent">
                    <span>
                      {selectedLanguage === "arabic"
                        ? "التفاصيل"
                        : "Particulars"}
                    </span>
                  </th>
                  <th className="bg-transparent">
                    <span>
                      {selectedLanguage === "arabic" ? "الكمية" : "Qty"}
                    </span>
                  </th>
                  {/* <th className="bg-transparent">
                    <span>
                      {selectedLanguage === "arabic" ? "Warranty" : "Warranty"}
                    </span>
                  </th> */}
                  <th className="bg-transparent">
                    <span>
                      {selectedLanguage === "arabic"
                        ? "سعر الوحدة"
                        : "Unit Price"}{" "}
                    </span>
                  </th>
                  <th className="bg-transparent">
                    <span>
                      {selectedLanguage === "arabic"
                        ? "المبلغ الإجمالي"
                        : "Total Amount"}{" "}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {OrderList?.map((item, index) => {
                  const isExpanded = expandedIndex === index;
                  const serials = JSON.parse(item.serial_number || "[]");
                  const unitPrice = Number(item.unit_price);
                  const qty = Number(item.qty);

                  return (
                    <React.Fragment key={index}>
                      <tr className="bg-transparent">
                        <td className="bg-transparent">{index + 1}</td>
                        <td className="bg-transparent" style={{ maxWidth: "240px" }}>{item.rawmaterial_name}
                          {/* {serials && serials.length > 0 ? (
                            <div style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                              {serials.join(", ")}
                            </div>
                          ) : (
                            <div style={{ fontSize: "0.80rem", color: "#ff0000", opacity: 0.55 }}>
                              No serial Number Available
                            </div>
                          )}*/}
                        </td>
                        <td className="bg-transparent">{item.qty}{" KG"}</td>
                        {/* <td className="bg-transparent">{item.warranty||"-"}</td> */}
                        <td className="bg-transparent">{item.unit_price}</td>
                        <td
                          className="bg-transparent"
                          onClick={() => toggleExpand(index)}
                          style={{ cursor: "pointer" }}
                        >
                          {(item.total || unitPrice * qty)}
                          {/* <i className={`fas fa-chevron-${isExpanded ? "up" : "down"} ms-2`}></i> */}
                        </td>
                      </tr>

                      {/* {isExpanded &&
        Array.from({ length: qty }).map((_, i) => (
          <tr key={`expanded-${index}-${i}`} className="bg-light text-muted">
            <td className="text-muted bg-light">{i + 1}</td>
            <td className="text-muted bg-light">{item.product_name} - Serial No: {serials[i] || ''}</td>
            <td className="text-muted bg-light">1</td>
            <td className="text-muted bg-light">{unitPrice}</td>
            <td className="text-muted bg-light">{unitPrice}</td>
          </tr>
        ))} */}
                    </React.Fragment>
                  );
                })}


                <tr>
                  <br />
                </tr>
                <tr>
                  <td className="bg-transparent  fw-bold text-end" colSpan={4}>
                    {selectedLanguage === "arabic" ? "الإجمالي" : "Total"}{" "}
                  </td>
                  <td className="bg-transparent">
                    {OrderList?.reduce(
                      (acc, item) =>
                        acc + (item?.unit_price * item?.qty || 0),
                      0
                    ).toFixed(0)}
                  </td>
                </tr>
                <tr>
                  <td className="bg-transparent  fw-bold text-end" colSpan={4}>
                    {selectedLanguage === "arabic" ? "الخصم" : "Discount"}
                  </td>
                  <td className="bg-transparent">
                    {state?.discount && state?.sub_total
                      ? "- " +
                      (
                        (parseFloat(state?.sub_total || 0) *
                          parseFloat(state?.discount || 0)) /
                        100
                      ).toFixed(0)
                      : "- 0.00"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-transparent  fw-bold text-end" colSpan={4}>
                    {selectedLanguage === "arabic" ? "الضريبة" : "Tax"}
                  </td>
                  <td className="bg-transparent">
                    {"+ " +
                      parseFloat(
                        (OrderList.reduce(
                          (acc, item) =>
                            acc +
                            parseFloat(item?.unit_price || 0) *
                            parseFloat(item?.qty || 0),
                          0
                        ) *
                          parseFloat(state?.vat || 0)) /
                        100
                      ).toFixed(0)}
                  </td>
                </tr>
                <tr>
                  <td className="bg-transparent  fw-bold text-end" colSpan={4}>
                    {selectedLanguage === "arabic"
                      ? "الإجمالي الكلي"
                      : "Grand Total"}
                  </td>
                  <td className="bg-transparent">
                    {parseFloat(state?.total || 0).toFixed(3)}
                  </td>
                </tr>
                {state.purchase_unit != 1 &&
                  <tr>
                    <td colSpan={5} className="text-center">Payment History</td>
                  </tr>
                }
                {state?.payment &&
                  state?.payment
                    ?.filter((item) => item.mop != "2")
                    ?.map((item, index) => (
                      <tr>
                        <td colSpan={3} className="text-end fw-bold px-2">{item.date}</td>
                        <td colSpan={1} className="text-end fw-bold px-2">{item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : ""}</td>
                        <td colSpan={1} className="text-center">{item.amount}</td>
                      </tr>
                    ))}
                {state.purchase_unit != 1 &&
                  <tr>
                    <td colSpan={4} className="text-end fw-bold px-2">{"Remaining Balance"}</td>
                    <td colSpan={1} className="text-center text-danger">{(parseFloat(state?.total || 0) - parseFloat(paidAmount || 0)).toFixed(3)}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchasePDF;
